import { getPathToPosition } from '../../utils/getReachablePath/index.js';
import rankNeighbourPositions from './rankNeighbourPositions.js';
import rankAgentUnitPositions from './rankAgentUnitPositions.js';
import modifyRankingForUnit from './modifyRankingForUnit.js';
function isThereNotBoldUnit(agentSide, gameState, rules) {
    const notBoldUnit = gameState.units.find((u) => u.side === agentSide && !rules.isUnitBold(u, gameState));
    if (!notBoldUnit) {
        return false;
    }
    return true;
}
const supportFriendlyUnitStrategyFactory = (agentSide, hexProperties, rules, mapHexes) => {
    return {
        name: 'supportFriendlyUnit',
        getMoveOrder: (gameState) => {
            if (!isThereNotBoldUnit(agentSide, gameState, rules)) {
                return null;
            }
            const rankedPositions = rankNeighbourPositions({
                allUnits: gameState.units,
                agentSide,
                hexProperties,
                rules,
            });
            const rankedUnitPositions = rankAgentUnitPositions({ gameState, agentSide, rules });
            rankedUnitPositions.sort((a, b) => {
                return a.rank - b.rank;
            });
            for (let i = 0; i < rankedUnitPositions.length; i += 1) {
                const unitPosition = rankedUnitPositions[i];
                if (unitPosition.rank >= 2) {
                    return null;
                }
                const unitOnPosition = rules.getUnitOnPosition(unitPosition, gameState.units);
                if (!unitOnPosition || unitOnPosition.isFatigued) {
                    continue;
                }
                const rankedPositionsForUnit = modifyRankingForUnit({
                    rankedPositions,
                    agentUnit: unitOnPosition,
                    rules,
                    gameState,
                    hexProperties,
                });
                rankedPositionsForUnit.sort((a, b) => {
                    return b.rank - a.rank;
                });
                for (const targetPosition of rankedPositionsForUnit) {
                    const path = getPathToPosition(unitOnPosition, targetPosition, hexProperties, rules, gameState.units, mapHexes);
                    if (path && path.length) {
                        return {
                            agentUnit: unitOnPosition,
                            targetPosition,
                            pathToTargetPosition: path,
                            targetEnemy: null,
                        };
                    }
                }
            }
            return null;
        },
    };
};
export default supportFriendlyUnitStrategyFactory;
